import { getReverseSortFunction } from "../modules/items/sortFunctions";

const getRowsWithSuperId = (items, superId, expandedItems, sortFunction, sortInDesc = false) => {
  // get all items with the requested super
  const thisLevel = items
    .filter(o => o.super === superId)
    .sort(sortInDesc ? getReverseSortFunction(sortFunction) : sortFunction);
  // Now work out if we need to get any nested children
  let allLevels = thisLevel;
  // Iterate through each item at this level...
  thisLevel.forEach(o => {
    if (o.children && expandedItems.contains(o.id)) {
      // This item is expanded with children, so make a recursive call to grab their children also
      const children = getRowsWithSuperId(items, o.id, expandedItems, sortFunction);
      // And now we want to insert them after this item.
      const insertionIndex = allLevels.findIndex(a => a.id === o.id);
      allLevels = allLevels.insert(insertionIndex + 1, children).flatten();
    }
  });
  // Return the items at this level
  return allLevels;
};

export { getRowsWithSuperId };
